module.exports = require("ngx-bootstrap/chronos");